<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">Filtrar por</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">

            <div v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')">
              <div v-if="role === 'SuperAdministrador'">
                <AccessibleElSelect
                  v-model="form.distribuidor.value"
                  prop="distribuidor"
                  :options="distribuidoresForAccessibleSelect"
                  :withFormItem="true"
                  id-prefix="apirequestfilter"
                  @select="handleSelectDistribuidor"
                >
                  <template slot="label">{{$t('distributors.distributor')}}</template>
                </AccessibleElSelect>
              </div>

              <AccessibleElSelect
                v-model="form.empresa.value"
                prop="empresa"
                :options="clientesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="apirequestfilter"
                @select="handleSelectCliente"
              >
                <template slot="label">{{$t('app.client')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <span id="api-request-filter-nombre-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('peticionapi.NombreAccion')}}</span>
              <el-form-item prop="NombreAccion">
                <el-input
                  class="w-full"
                  v-model="form.NombreAccion.value"
                  maxlength="30"
                  aria-labelledby="api-request-filter-nombre-label"
                >
                  <template v-if="form.NombreAccion.value" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo de nombre de acción"
                      @clear="form.NombreAccion.value = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>
            
             <div>
              <AccessibleElSelect
                v-model="form.Activo.value"
                prop="Activo"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="apirequestfilter"
              >
                <template slot="label">{{$t('app.active')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.TipoAutenticacion.value"
                prop="TipoAutenticacion"
                :options="tiposAutenticacionForAccessibleSelect"
                :withFormItem="true"
                id-prefix="apirequestfilter"
              >
                <template slot="label">{{$t('peticionapi.TipoAutenticacion')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.Metodo.value"
                prop="Metodo"
                :options="tiposMetodoForAccessibleSelect"
                :withFormItem="true"
                id-prefix="apirequestfilter"
              >
                <template slot="label">{{$t('peticionapi.Metodo')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <span id="api-request-filter-contenttype-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('peticionapi.ContentType')}}</span>
              <el-form-item prop="ContentType">
                <el-input
                  class="w-full"
                  v-model="form.ContentType.value"
                  maxlength="50"
                  aria-labelledby="api-request-filter-contenttype-label"
                >
                  <template v-if="form.ContentType.value" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo de ContentType"
                      @clear="form.ContentType.value = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>
            
             <div>
              <AccessibleElSelect
                v-model="form.Automatico.value"
                prop="Automatico"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="apirequestfilter"
              >
                <template slot="label">{{$t('peticionapi.Automatico_Grid')}}</template>
              </AccessibleElSelect>
            </div>
            
             <div>
              <AccessibleElSelect
                v-model="form.EjecucionUnica.value"
                prop="EjecucionUnica"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="apirequestfilter"
              >
                <template slot="label">{{$t('peticionapi.EjecucionUnica')}}</template>
              </AccessibleElSelect>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'
import { getDistributors } from '@/services/distributors/getDistributors'
import { getClients } from '@/services/clients/getClients'
import { TIPOS_AUTENTICACION_API } from '@/config/tipos-autenticacion-api'
import { TIPOS_METHODS } from '@/config/tipos-methods' 
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue' 

export default {
  name: 'filter-panel',
  components: {
    AccessibleElSelect
  },
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      vuexnamespace: 'apirequests',
      TiposAutenticacion: TIPOS_AUTENTICACION_API,
      tiposMetodo: TIPOS_METHODS,
      isOpen: this.panelOpen,
      form: {
        NombreAccion: { label: i18n.t('peticionapi.NombreAccion'), value: '' },
        Activo: { label: i18n.t('app.active'), value: '' },
        TipoAutenticacion: { label: i18n.t('peticionapi.TipoAutenticacion'), value: '' },
        Metodo: { label: i18n.t('peticionapi.Metodo'), value: '' },
        ContentType: { label: i18n.t('peticionapi.ContentType'), value: '' },
        Automatico: { label: i18n.t('peticionapi.Automatico_Grid'), value: '' },
        EjecucionUnica: { label: i18n.t('peticionapi.EjecucionUnica'), value: '' },

        distribuidor: { label: i18n.t('distributors.distributor'), value: '' },
        empresa: { label: i18n.t('app.client'), value: '' },
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      distribuidores: [],
      clientes: [],
    }
  },

  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  mounted: async function () {
    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
      }
      this.clientes = dataClients.Empresas

      if (this.role === 'SuperAdministrador') {
        const dataDistributors = await getDistributors()
        if (dataDistributors.blnError === true) {
          this.doFeedback(dataDistributors.msgError + ' [Código de error: ' + dataDistributors.codError + ']')
        }
        this.distribuidores = dataDistributors.Distribuidores
      }
    } 
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    distribuidoresForAccessibleSelect: function () {
      return this.distribuidores.map(item => ({
        id: item.IdDistribuidor,
        name: item.Nombre,
        value: item.Nombre
      }))
    },
    clientesForAccessibleSelect: function () {
      return this.clientes.map(item => ({
        id: item.IdEmpresa,
        name: item.Nombre,
        value: item.Nombre
      }))
    },
    tiposAutenticacionForAccessibleSelect: function () {
      return this.TiposAutenticacion.map(item => ({
        id: item.id,
        name: item.name
      }))
    },
    tiposMetodoForAccessibleSelect: function () {
      return this.tiposMetodo.map(item => ({
        id: item.value,
        name: item.value
      }))
    },
    valuesForAccessibleSelect: function () {
      return this.values.map(item => ({
        id: item.value,
        name: item.label
      }))
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.NombreAccion.value = _temp.NombreAccion !== undefined && _temp.NombreAccion.value !== '' ? _temp.NombreAccion.value : ''
        this.form.Activo.value = _temp.Activo !== undefined && _temp.Activo.value !== '' ? _temp.Activo.value : ''
        this.form.TipoAutenticacion.value = _temp.TipoAutenticacion !== undefined && _temp.TipoAutenticacion.value !== '' ? _temp.TipoAutenticacion.value : ''
        this.form.Metodo.value = _temp.Metodo !== undefined && _temp.Metodo.value !== '' ? _temp.Metodo.value : ''
        this.form.Automatico.value = _temp.Automatico !== undefined && _temp.Automatico.value !== '' ? _temp.Automatico.value : ''
        this.form.EjecucionUnica.value = _temp.EjecucionUnica !== undefined && _temp.EjecucionUnica.value !== '' ? _temp.EjecucionUnica.value : ''
        this.form.ContentType.value = _temp.ContentType !== undefined && _temp.ContentType.value !== '' ? _temp.ContentType.value : ''
        this.form.distribuidor.value = _temp.distribuidor !== undefined && _temp.distribuidor.value !== '' ? _temp.distribuidor.value : ''
        this.form.empresa.value = _temp.empresa !== undefined && _temp.empresa.value !== '' ? _temp.empresa.value : ''
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        NombreAccion: { label: i18n.t('peticionapi.NombreAccion'), value: '' },
        Activo: { label: i18n.t('app.active'), value: '' },
        TipoAutenticacion: { label: i18n.t('peticionapi.TipoAutenticacion'), value: '' },
        Metodo: { label: i18n.t('peticionapi.Metodo'), value: '' },
        ContentType: { label: i18n.t('peticionapi.ContentType'), value: '' },
        Automatico: { label: i18n.t('peticionapi.Automatico_Grid'), value: '' },
        EjecucionUnica: { label: i18n.t('peticionapi.EjecucionUnica'), value: '' },

        distribuidor: { label: i18n.t('distributors.distributor'), value: '' },
        empresa: { label: i18n.t('app.client'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
    querySearch: function (queryString, cb) {
      const links = this.links
      const results = queryString ? links.filter(this.createFilter(queryString)) : links
      // call callback function to return suggestions
      cb(results)
    },
    createFilter: function (queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    handleSelectCliente: function (item) {
      this.form.empresa.value = item.id
    },
    handleSelectDistribuidor: function (item) {
      this.form.distribuidor.value = item.id
    },
  }
}
</script>
